import { FC } from 'react';
import SearchIcon from '../../../../assets/images/svg/SearchIcon';
import { CustomClassContainerProps, CustomClassContainer } from '../../utility';
import useDebounce from '../../../hooks/useDebounce';
import { nullFn } from '../../../utils';

interface TextInputProps extends CustomClassContainerProps {
  name: string;
  placeholder?: string;
  type?: string;
  delay: number;
  onDebouncedChange: (arg0: string) => void;
}

const SearchInput: FC<TextInputProps> = ({
  name,
  placeholder,
  type,
  classes,
  delay,
  onDebouncedChange,
}) => {
  const [val, handleInputChange] = useDebounce('', delay, onDebouncedChange);

  return (
    <CustomClassContainer classes={classes}>
      <div className='flex w-auto flex-col'>
        <span className='absolute flex h-9.5 items-center pl-2'>
          <button
            type='submit'
            className='focus:shadow-outline p-1 focus:outline-none'
            onClick={nullFn}
          >
            <SearchIcon />
          </button>
        </span>
        <input
          className='appearance-none rounded-md border border-gray-lightest py-2 pl-10 pr-5 text-sm font-medium placeholder-gray-light shadow-sm focus:border-transparent focus:outline-none focus:ring-2 focus:ring-green'
          id={name}
          name={name}
          type={type ? type : 'text'}
          placeholder={placeholder ? placeholder : ''}
          value={val}
          onChange={handleInputChange}
        />
      </div>
    </CustomClassContainer>
  );
};

export default SearchInput;
